import { container } from 'tsyringe';
import { DateTime, Interval } from 'luxon';
import { CommandName } from '../commands/command-name.enum';
import { AuthorizationService } from '../services/authorization.service';
import { ICalExporterService } from '../services/i-cal-exporter.service';
import { hasPrivilege } from '../helpers/privilege.helper';
import { ActionIds } from './action.types';
import type { ActionRegistryImpl } from './action-registry';

/**
 * Registers all backend-interaction actions with the given registry.
 *
 * Backend actions trigger calls to backend services (export, authentication).
 * Includes: export.icalCurrentYear, auth.logout.
 *
 * @param registry - The ActionRegistryImpl to register actions with.
 */
export function registerBackendActions(registry: ActionRegistryImpl): void {
    registry.register({
        id: ActionIds.EXPORT_ICAL_CURRENT_YEAR,
        label: 'Export iCal Current Year',
        category: 'export',
        canExecute: () => hasPrivilege(CommandName.EXPORT_ICAL_CURRENT_YEAR),
        execute: async () => {
            const startOfYear = DateTime.utc().startOf('year');
            const iCalExporter = container.resolve(ICalExporterService);
            await iCalExporter.exportAsDownload(
                `Termine im Jahr ${startOfYear.year}`,
                Interval.fromDateTimes(startOfYear, startOfYear.plus({ year: 1 }))
            );
        },
    });

    registry.register({
        id: ActionIds.AUTH_LOGOUT,
        label: 'Logout',
        category: 'system',
        // TODO: Tech-Debt — hasPrivilege(LOGOUT) may block non-admin users from logging out.
        // Legacy behavior is preserved 1:1. Consider: canExecute: () => true in a future PRD.
        canExecute: () => hasPrivilege(CommandName.LOGOUT),
        execute: () => {
            container.resolve(AuthorizationService).logout();
        },
    });
}
